import { render } from "./ProcessDetail.vue?vue&type=template&id=426fcacc&scoped=true&ts=true&lang=pug"
import script from "./ProcessDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcessDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ProcessDetail.vue?vue&type=style&index=0&id=426fcacc&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426fcacc"]])

export default __exports__